// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWD3LBNtPaczvj1j7H18TpBAZPosYV5zQ",
  authDomain: "dragon-news-56a6f.firebaseapp.com",
  projectId: "dragon-news-56a6f",
  storageBucket: "dragon-news-56a6f.appspot.com",
  messagingSenderId: "117143954391",
  appId: "1:117143954391:web:d65799edee3acc7246a192"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;